import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FalconComponentCard from 'components/common/FalconComponentCard';
import Flex from 'components/common/Flex';
import IconButton from 'components/common/IconButton';
import Editor from 'components/editor/Editor';
import useApi from 'helpers/api';
import useNotification from 'hooks/useNotification';
import { useEffect, useRef, useState } from 'react';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import CustomerContactsService from 'services/CustomerContacts.service';

const AssetRegistration = () => {
  const api = useApi();
  const { showSuccessNotification, showErrorNotification } = useNotification();
  const navigate = useNavigate();
  const inputCustomer = useRef(null);

  const [formData, setFormData] = useState({
    inactive: false,
    fields: []
  });
  const [showMenuCustomer, setShowMenuCustomers] = useState(false);
  const [showCustomFields, setShowCustomFields] = useState(true);

  const [filterQuery, setFilterQuery] = useState({
    size: 1000,
    name: ''
  });

  const [assetTypes, setAssetTypes] = useState([]);
  const [customFields, setCustomFields] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [contacts, setContacts] = useState([]);

  useEffect(() => {
    getAssetTypes();
  }, []);

  useEffect(() => {
    console.log(formData);
  }, [formData]);

  useEffect(() => {
    getCustomers();
  }, [filterQuery.name]);

  useEffect(() => {
    getContacts();
  }, [formData.customer]);

  useEffect(() => {
    getCustomFields();
  }, [formData.assetType]);

  useEffect(() => {
    if (customFields.length > 0) {
      const initialFields = customFields.map(field => ({
        fieldId: field.id,
        value: null
      }));

      setFormData(prev => ({
        ...prev,
        fields: initialFields
      }));
    }
  }, [customFields]);

  const getAssetTypes = async () => {
    const queryParams = new URLSearchParams(filterQuery).toString();
    const response = await api.assetTypes.list(queryParams);

    response.content && setAssetTypes(response.content);
  };

  const getCustomers = async () => {
    if (filterQuery.name != '') {
      const queryParams = new URLSearchParams(filterQuery).toString();
      const response = await api.customers.list(queryParams);

      response.content && setCustomers(response.content);
    }
  };

  const getContacts = async () => {
    if (formData.customer?.id) {
      const queryParams = new URLSearchParams(filterQuery).toString();
      const response = await CustomerContactsService.list(
        formData.customer.id,
        queryParams
      );

      response.content && setContacts(response.content);
    }
  };

  const getCustomFields = async () => {
    if (formData.assetType?.id) {
      const response = await api.assetTypes.customFields.list(
        formData.assetType.id
      );
      if (Array.isArray(response)) {
        setCustomFields(response);
      }
    }
  };

  const formatDateTimeToFormData = dateTimeString => {
    return dateTimeString.slice(0, 16);
  };

  const mapPropertyValue = prop => {
    if (!prop.assetPropertyValue) return '';

    const {
      stringValue,
      intValue,
      decimalValue,
      textValue,
      boolValue,
      datetimeValue
    } = prop.assetPropertyValue;
    const type = prop.dataType;

    const valueMap = {
      TEXT: stringValue || '',
      DROPDOWN: stringValue || null,
      DATETIME: datetimeValue ? formatDateTimeToFormData(datetimeValue) : null,
      INTEGER: intValue ? parseInt(intValue) : null,
      DECIMAL: decimalValue ? parseFloat(decimalValue) : null,
      TEXT_AREA: textValue || '',
      CHECKBOX: boolValue
    };

    return valueMap[type] ?? null;
  };

  const updatePropertyValue = (dataType, value, checked) => {
    switch (dataType) {
      case 'TEXT':
      case 'TEXT_AREA':
      case 'DROPDOWN':
        return value || null;

      case 'INTEGER':
        return value !== '' && !isNaN(value) ? parseInt(value, 10) : null;

      case 'DECIMAL':
        return value !== '' && !isNaN(value) ? parseFloat(value) : null;

      case 'CHECKBOX':
        return checked;

      case 'DATETIME':
        return value || null;

      default:
        return value;
    }
  };

  const handleChangeCustomFields = (e, fieldId, dataType) => {
    const { value, type, checked } = e.target;
    const updatedValue = updatePropertyValue(dataType, value, checked);

    const fieldExists = formData.fields.some(
      f => f.fieldId === fieldId
    );

    if (fieldExists) {
      setFormData(prev => ({
        ...prev,
        fields: prev.fields.map(field =>
          field.fieldId === fieldId
            ? {
                ...field,
                value: updatedValue
              }
            : field
        )
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        fields: [
          ...prev.fields,
          {
            fieldId: fieldId,
            value: updatedValue
          }
        ]
      }));
    }
  };

  const handleChange = (e, isId) => {
    const { name, value } = e.target;
    if (isId) {
      setFormData(prev => ({
        ...prev,
        [name]: { id: parseInt(value) }
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };

  const isValidValue = value => {
    return value !== '' && value !== null && value !== undefined;
  };

  const handleSubmit = async e => {
    e.preventDefault();

    const filteredFields = formData.fields.filter(field =>
      isValidValue(field.value)
    );

    const filteredFormData = {
      ...formData,
      fields: filteredFields
    };

    if (!formData.contact?.id || formData.contact?.id === 0) {
      delete filteredFormData.contact;
    }

    const response = await api.assets.create(filteredFormData);

    if (response.id) {
      showSuccessNotification('Ativo cadastrado com sucesso');

      setTimeout(() => {
        navigate('/assets');
      }, 2000);
    } else {
      showErrorNotification(response.userMessage || 'Erro ao cadastrar ativo');
    }
  };

  return (
    <>
      <FalconComponentCard>
        <Card.Header>
          <Flex alignItems="center" justifyContent="between" className="w-100">
            <Flex alignItems="center">
              <IconButton
                onClick={() => navigate(-1)}
                variant="falcon-default"
                size="sm"
                icon="arrow-left"
                className="me-2"
              />
              <h3>Criar ativo</h3>
            </Flex>
          </Flex>
        </Card.Header>

        <FalconComponentCard.Body>
          <Form onSubmit={handleSubmit}>
            <Row>
              <Form.Group as={Col} md="6" className="mb-3">
                <Form.Label>
                  Nome <span className="text-danger"> *</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  value={formData.name || ''}
                  required
                  onChange={handleChange}
                />
              </Form.Group>

              <Form.Group as={Col} md="6" className="mb-3">
                <Form.Label>Número de série</Form.Label>
                <Form.Control
                  type="text"
                  name="serialNumber"
                  value={formData.serialNumber || ''}
                  onChange={handleChange}
                />
              </Form.Group>

              <Form.Group as={Col} md="4" className="mb-3">
                <Form.Label>
                  Tipo de ativo <span className="text-danger"> *</span>
                </Form.Label>
                <Form.Select
                  name="assetType"
                  value={formData.assetType?.id || ''}
                  onChange={e => handleChange(e, true)}
                  required
                >
                  <option value="">Selecione...</option>
                  {assetTypes.map(type => (
                    <option key={type.id} value={type.id}>
                      {type.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>

              <Form.Group as={Col} md="4" className="mb-3">
                <Form.Label>
                  Cliente <span className="text-danger"> *</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Digite para pesquisar"
                  value={filterQuery.name}
                  ref={inputCustomer}
                  autoComplete="off"
                  autoCorrect="off"
                  autoCapitalize="off"
                  spellCheck="false"
                  onFocus={() => setShowMenuCustomers(true)}
                  onChange={e =>
                    setFilterQuery(prevFilters => ({
                      ...prevFilters,
                      name: e.target.value
                    }))
                  }
                />
                {showMenuCustomer && customers.length > 0 && (
                  <ul
                    className="position-sticky px-0 list-customer bg-100 shadow rounded z-3"
                    style={{
                      height: 'auto',
                      maxHeight: 350,
                      overflowY: 'auto'
                    }}
                  >
                    {customers.map(item => (
                      <li
                        style={{ listStyleType: 'none', cursor: 'pointer' }}
                        className="px-3 py-2 bg-primary-hover item-list-hover"
                        data-value={item.id}
                        key={item.id + item.type}
                        onClick={() => {
                          setFilterQuery(prevFilters => ({
                            ...prevFilters,
                            name: item.fantasyName || item.name
                          }));
                          setFormData({
                            ...formData,
                            customer: { id: item.id }
                          });
                          setShowMenuCustomers(false);
                        }}
                      >
                        {item.fantasyName || item.name}
                      </li>
                    ))}
                  </ul>
                )}
              </Form.Group>

              <Form.Group as={Col} md="3" className="mb-3">
                <Form.Label>Contato</Form.Label>
                <Form.Select
                  name="contact"
                  value={formData.contact?.id || ''}
                  onChange={e => handleChange(e, true)}
                >
                  <option value="">Selecione...</option>
                  {contacts.map(contact => (
                    <option key={contact.id} value={contact.id}>
                      {contact.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>

              <Form.Group as={Col} md="1" className="mb-3">
                <Form.Label>Ativo</Form.Label>
                <Form.Check
                  type="switch"
                  name="inactive"
                  checked={!formData.inactive}
                  onChange={() =>
                    setFormData({ ...formData, inactive: !formData.inactive })
                  }
                />
              </Form.Group>

              <Form.Group as={Col} md="12" className="mb-3">
                <Form.Label>Descrição</Form.Label>
                <Editor
                  data={formData.description || ''}
                  value={value =>
                    setFormData({ ...formData, description: value })
                  }
                />
              </Form.Group>
            </Row>

            <Row className="mt-5">
              <Flex
                role="button"
                className="bg-100 py-2 mb-2"
                alignItems={'center'}
                onClick={() => setShowCustomFields(!showCustomFields)}
              >
                <FontAwesomeIcon
                  icon={showCustomFields ? faChevronUp : faChevronDown}
                  size="sm"
                  className="me-2"
                />
                <h5>Campos Personalizados</h5>
              </Flex>

              {showCustomFields &&
                customFields?.map(field => {
                  const fieldData = formData.fields.find(
                    f => f.fieldId === field.id
                  );

                  return (
                    <Form.Group className="mb-3" as={Col} md={6} key={field.id}>
                      <Form.Label>
                        {field.name}{' '}
                        {field.required && (
                          <span className="text-danger"> *</span>
                        )}
                      </Form.Label>
                      {renderPropertyInput(
                        field,
                        fieldData?.value,
                        handleChangeCustomFields
                      )}
                    </Form.Group>
                  );
                })}
            </Row>

            <Flex className="w-100" justifyContent="end">
              <Button
                as={Link}
                to={`/assets`}
                variant="falcon-default"
                className="me-2"
              >
                Cancelar
              </Button>
              <Button type="submit">Salvar</Button>
            </Flex>
          </Form>
        </FalconComponentCard.Body>
      </FalconComponentCard>
    </>
  );
};

const renderPropertyInput = (property, value, handleChange) => {
  const { dataType, id, dropdownOptions, required } = property;

  switch (dataType) {
    case 'TEXT':
      return (
        <Form.Control
          type="text"
          value={value || ''}
          required={required}
          onChange={e => handleChange(e, id, dataType)}
        />
      );
    case 'INTEGER':
      return (
        <Form.Control
          type="number"
          value={value || ''}
          required={required}
          onChange={e => handleChange(e, id, dataType)}
        />
      );
    case 'DECIMAL':
      return (
        <Form.Control
          type="number"
          step="0.01"
          value={value || ''}
          required={required}
          onChange={e => handleChange(e, id, dataType)}
        />
      );
    case 'TEXT_AREA':
      return (
        <Form.Control
          as="textarea"
          rows={2}
          value={value || ''}
          required={required}
          onChange={e => handleChange(e, id, dataType)}
        />
      );
    case 'CHECKBOX':
      return (
        <Form.Check
          type="checkbox"
          checked={!!value}
          required={required}
          onChange={e => handleChange(e, id, dataType)}
        />
      );
    case 'DROPDOWN':
      return (
        <Form.Select
          value={value || ''}
          required={required}
          onChange={e => handleChange(e, id, dataType)}
        >
          <option value="">Selecione...</option>
          {dropdownOptions.map(option => (
            <option key={option.id} value={option.value}>
              {option.label}
            </option>
          ))}
        </Form.Select>
      );
    case 'DATETIME':
      return (
        <Form.Control
          type="datetime-local"
          value={value || ''}
          required={required}
          onChange={e => handleChange(e, id, dataType)}
        />
      );
    default:
      return <p>Tipo não suportado</p>;
  }
};

export default AssetRegistration;
